import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";

export interface ValidateArticle {
  id: string;
  price: number;
  vat_rate: number;
  full_lot_number: string;
}
export interface fetchValidateArguments {
  articles?: ValidateArticle[];
  shopping_cart_validation: boolean;
}
export interface ValidationError {
  id?: string;
  error: string;
}
export interface fetchValidateResponse {
  data?: {
    errors?: ValidationError[];
  }
};

export function fetchValidate({ articles, shopping_cart_validation }: fetchValidateArguments): Promise<AxiosResponse<fetchValidateResponse, any>> {
  const payload = {
    lot_offers: articles?.map((article) => ({
      id: article.id,
      price: article.price,
      vat_rate: article.vat_rate,
      full_lot_number: article.full_lot_number,
    })),
    shopping_cart_validation: shopping_cart_validation,
  };
  return axiosInstance.post(`customer/purchases/validate`, payload);
}

export interface postPurchaseArguments {
  articles: ValidateArticle[];
}

export interface postPurchaseResponse {
  data?: {
    taken_lot_offer_ids?: string[];
    overflown_lot_offer_ids?: string[];
  };
}

export function postPurchase({ articles }: postPurchaseArguments): Promise<AxiosResponse<postPurchaseResponse, any>> {
  const payload = {
    lot_offers: articles,
  };
  return axiosInstance.post(`customer/purchases`, payload);
}
